module.exports = __webpack_public_path__ + "static/img/network.f4de3b34.svg";